import { StrictMode, startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import { initSentryClient } from './helpers/monitoring.client';
import { loadGTM } from './helpers/script';

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );

  loadGTM();
  initSentryClient();
});
